// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { DOCUMENT } from "@angular/common";

export const environment = {
  production: false,

  //APIURL: 'https://localhost:60818',
  //APIURL: 'https://uatapis.edelweissalternatives.com/swiftstagging',
  APIURL: 'https://apis.eaaa.in/swiftapi',
  DOC_URL: 'https://localhost:44349/uploads',
  MASTERAPIURL: 'https://apis.eaaa.in',
  // MASTERAPIURL:'https://localhost:44343/',
  MASTERCORE: 'https://apis.eaaa.in',
  // LINUX: 'https://swift.eaaa.in/prod',
  LINUX: 'https://swift.eaaa.in',
  DOC_DOWNLOAD: 'https://apis.eaaa.in/drawdown',
  RT_LOGIN: 'https://swift.eaaa.in',
  DIGIO_URL: 'https://app.digio.in/#/gateway/login/',
  REASSIGNMENT_FOLDER: 'SWIFTLIVE/rmcxoreassignment'

  // MASTERAPIURL:'https://uatapis.edelweissalternatives.com/api',
};